var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"guest-page"},[_c('div',{staticClass:"fill-height",attrs:{"id":"auth"}},[_c('v-layout',{attrs:{"wrap":"","fill-height":"","justify-center":"","align-content-center":""}},[_c('div',{staticClass:"d-block"},[_vm._t("default")],2)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }